<mat-card class="daxa-card recent-customer-rating-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mb-0">
                {{ 'Customer devices' | translate }}
            </h5>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class="recent-customer-rating-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource">

                    <ng-container matColumnDef="settingId">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Setting ID' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.settingId }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="owner">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Owner' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.owner }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="serialNumber">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Serial_number' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.serialNumber }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="systemCapacity">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'System_Capacity' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.systemCapacity | number:'1.2-2' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Timezone">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Time_zone' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.Timezone }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="smartCharge">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Smart_Charge' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.smartCharge | number:'1.2-2' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="panelPower">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Panel_Power' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.panelPower | number:'1.2-2' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="lowPriceThreshold">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ 'Low_price_threshold' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.lowPriceThreshold | number:'1.2-2' }}
                        </td>
                    </ng-container>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="8">
                            @if (isLoading) {
                            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                            } @else {
                            <div class="text-center py-3">
                                {{ 'No data found' | translate }}
                            </div>
                            }
                        </td>
                    </tr>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </div>
    </mat-card-content>
</mat-card>